module.exports = __webpack_public_path__ + "img/24.89d27b74.jpg";